import styled from 'styles/styled';

export const Wrap = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Tab = styled.div`
  display: flex;
  gap: 14px;
  border-bottom: 1px solid #2A2E34;
  margin-bottom: 8px;
`;

export const Button = styled.button`
  background: transparent;
  border: 0;
  cursor: pointer;
  color: #7A7E8C;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  padding: 6px 0;
  border-bottom: 2px solid transparent;
  transition: color 200ms, border-color 200ms;

  &:hover {
    color: #EFEFEF;
  }

  &.active {
    color: #EFEFEF;
    border-color: #52D381;
    font-weight: 700;
  }
`;

export const ScrollWrap = styled.div`
  overflow-y: auto;
  overflow-x: auto;
  max-height: 320px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #2A2E34;
    border-radius: 4px;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;
`;

export const Th = styled.th`
  font-size: 10px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #7A7E8C;
  font-weight: 600;
  text-align: left;
  padding: 8px 10px;
  background: #15191E;
  position: sticky;
  top: 0;
  z-index: 1;
  white-space: nowrap;

  &.right {
    text-align: right;
  }
`;

export const Td = styled.td`
  font-size: 12px;
  color: #EFEFEF;
  padding: 8px 10px;
  border-top: 1px solid #2A2E34;
  white-space: nowrap;

  &.muted {
    color: #A7A8B2;
  }

  &.right {
    text-align: right;
  }

  &.up_state {
    color: #52D381;
  }

  &.down_state {
    color: #FF6782;
  }
`;

export const Tr = styled.tr`
  transition: background 120ms;

  &:hover {
    background: rgba(255, 255, 255, 0.02);
  }
`;

export const PairCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PairIcon = styled.span<{ $src?: string }>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-image: ${(p) => (p.$src ? `url(${p.$src})` : 'none')};
  background-size: cover;
  background-position: center;
  background-color: #292B2E;
  flex-shrink: 0;
`;

export const TypeBadge = styled.span<{ $type?: 'buy' | 'sell' }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${(p) => (p.$type === 'sell' ? '#FF6782' : '#52D381')};
  background: ${(p) =>
    p.$type === 'sell' ? 'rgba(255, 103, 130, 0.12)' : 'rgba(82, 211, 129, 0.12)'};
`;

export const Empty = styled.div`
  font-size: 12px;
  color: #7A7E8C;
  text-align: center;
  padding: 24px;
`;
